import { useMutation } from '@tanstack/react-query';
import { policiesService } from '../../../services/policies';
import { downloadBlob } from '../../../shared/utils/download-blob.util';

interface DownloadPolicyPdfParams {
  policyId: string;
  policyNo: string;
}

export function usePolicyPdf() {
  return useMutation({
    retry: false,
    mutationFn: async ({ policyId, policyNo }: DownloadPolicyPdfParams) => {
      const blob = await policiesService.getPolicyPdf(policyId);
      downloadBlob(blob, `apolice-${policyNo}.pdf`);
    },
  });
}
